import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PassportDetailsStore } from '../shared/passport-details.store';
import { PassportDetailsComponent } from '../passport-details/passport-details.component';
import { UiStateService } from '../shared/ui-state.service';
import { BasePassportCellComponent } from '../shared/base-passport-cell.component';

@Component({
  selector: 'app-shunting-passport-cell',
  standalone: true,
  imports: [CommonModule, PassportDetailsComponent],
  templateUrl: '../shared/passport-cell.template.html',
  styleUrl: './shunting-passport-cell.component.css'
})
export class ShuntingPassportCellComponent extends BasePassportCellComponent {
  // Extra inputs specific to shunting
  @Input() growerName = '';
  @Input() bulker = '';

  protected get personaName(): string {
    return 'shunting';
  }

  constructor(router: Router, details: PassportDetailsStore, ui: UiStateService) {
    super(router, details, ui);
  }

  /**
   * Override to create header with tags for comments
   */
  protected override createPassportHeader() {
    return {
      loadNumber: this.loadNumber,
      scheduledText: this.scheduledText,
      tags: [this.variety, this.haulier], // Shunting includes tags by default
      variety: this.variety,
      haulier: this.haulier,
      origin: this.origin,
      destination: this.destination,
      apnName: this.apnName,
      vendorName: this.vendorName,
      vendorNumber: this.vendorNumber,
      bulkerNumber: this.bulkerNumber
    };
  }

  /**
   * Override openComments to use header with tags
   */
  override openComments(): void {
    const id = this.getRecordId();
    const header = this.createPassportHeader();
    
    // Check if desktop view (window width >= 768px)
    const isDesktop = globalThis.window !== undefined && globalThis.window.innerWidth >= 768;
    
    if (isDesktop) {
      // Use service to open comments panel for desktop
      this.commentsPanelService.openCommentsPanel(id, header);
    } else {
      // Save scroll position and set returning flag before navigating (mobile only)
      this.scrollPositionService.saveScrollPosition('/shunting');
      this.scrollPositionService.setReturningFromDetail(true);
      // Navigate to comments page for mobile
      void this.router.navigate(['/comments'], { state: { passportId: id, header } });
    }
  }
}

